(function () {
  'use strict';
  function initialise(root) {
    root.querySelectorAll('.fourc-card:not(.is-ready)').forEach(function (card) {
      var kind = card.dataset.kind;
      var current = (card.dataset.current || '').trim().toUpperCase();
      var buttons = Array.from(card.querySelectorAll('[data-stop]'));
      if (!buttons.length) return;
      var rail = card.querySelector('.fourc-card__choices');
      var previous = card.querySelector('[data-guide-prev]');
      var next = card.querySelector('[data-guide-next]');
      function updateArrows() {
        previous.disabled = rail.scrollLeft <= 1;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      }
      function centre(button) {
        var bounds = rail.getBoundingClientRect();
        var selected = button.getBoundingClientRect();
        rail.scrollTo({left: rail.scrollLeft + selected.left - bounds.left - (bounds.width - selected.width) / 2, behavior: 'instant'});
        updateArrows();
      }
      function move(direction) {
        rail.scrollBy({left: direction * rail.clientWidth * 0.75, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      previous.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      rail.addEventListener('scroll', updateArrows, {passive:true});
      new ResizeObserver(function () { updateArrows(); }).observe(rail);
      var initial = current;
      if (kind === 'colour') {
        if (/^[N-R]$/.test(current)) initial = 'NR';
        if (/^[S-Z]$/.test(current)) initial = 'SZ';
      }
      if (kind === 'cut') initial = ({IDEAL:'ID',EXCELLENT:'EX','VERY GOOD':'VG',VERYGOOD:'VG',GOOD:'G',FAIR:'F',POOR:'P'})[current] || current;
      if (kind === 'fancy') {
        var match = [['VIVID','vivid'],['INTENSE','intense'],['DEEP','deep'],['DARK','dark'],['FANCY LIGHT','fancy_light'],['VERY LIGHT','very_light'],['FAINT','faint'],['LIGHT','light'],['FANCY','fancy']].find(function (pair) { return current.indexOf(pair[0]) >= 0; });
        initial = match ? match[1] : 'fancy';
      }
      if (kind === 'carat') {
        var weight = Number(current);
        initial = buttons.reduce(function (nearest, button) {
          return Math.abs(Number(button.dataset.stop.replace('_','.')) - weight) < Math.abs(Number(nearest.dataset.stop.replace('_','.')) - weight) ? button : nearest;
        }, buttons[0]).dataset.stop;
      }
      if (!buttons.some(function (button) { return button.dataset.stop === initial; })) initial = buttons[0].dataset.stop;
      function select(value) {
        var button = buttons.find(function (item) { return item.dataset.stop === value; });
        if (!button) return;
        var index = buttons.indexOf(button);
        buttons.forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
        card.dataset.show = value;
        centre(button);
        card.querySelector('[data-guide-title]').textContent = button.dataset.title;
        card.querySelector('[data-guide-body]').textContent = button.dataset.body;
        if (kind === 'carat') {
          card.querySelector('.fourc-card__hand').style.backgroundPosition = (index % 3 * 50) + '% ' + (index > 2 ? 100 : 0) + '%';
        }
        if (kind === 'colour') card.style.setProperty('--stone-tint', 'rgba(217,176,57,' + (index * 0.027) + ')');
        if (kind === 'fancy') {
          var hues = {PINK:'222,116,156',YELLOW:'228,187,33',BLUE:'74,149,209',GREEN:'87,153,103',ORANGE:'223,144,57',BROWN:'153,106,57',GRAY:'112,116,124',GREY:'112,116,124',BLACK:'48,49,52',RED:'199,74,75',PURPLE:'162,104,187',VIOLET:'137,106,191'};
          var words = current.split(/\s+/), hue = '228,187,33';
          words.forEach(function (word) { if (hues[word]) hue = hues[word]; });
          card.style.setProperty('--stone-tint', 'rgba(' + hue + ',' + [0.08,0.13,0.2,0.27,0.4,0.54,0.7,0.64,0.62][index] + ')');
          card.style.setProperty('--stone-filter', 'brightness(' + (value === 'deep' ? 0.75 : value === 'dark' ? 0.55 : 1) + ')');
        }
        if (kind === 'clarity') {
          var counts = [0,0,1,2,2,3,3,4,4,5,6], sizes = [0,0,2,2,3,3,4,5,6,8,10];
          card.style.setProperty('--mark-size', sizes[index] + 'px');
          card.querySelectorAll('.fourc-card__marks i').forEach(function (mark, i) { mark.style.display = i < counts[index] ? 'block' : 'none'; });
        }
        if (kind === 'cut') {
          card.style.setProperty('--leak', [0,0,0.25,0.5,0.75,1][index]);
          card.style.setProperty('--return', [1,1,0.9,0.75,0.5,0.3][index]);
          card.style.setProperty('--stone-filter', 'brightness(' + [1,1,0.96,0.9,0.82,0.74][index] + ')');
        }
      }
      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () { select(button.dataset.stop); });
        button.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault(); buttons[next].focus(); select(buttons[next].dataset.stop);
        });
      });
      card.querySelector('[data-guide-reset]').addEventListener('click', function () { select(initial); });
      card.classList.add('is-ready'); select(initial);
      requestAnimationFrame(function () { centre(buttons.find(function (button) { return button.dataset.stop === initial; })); });
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
